import React from 'react';
import * as css from './Row.css';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import Checkbox from '../../checkbox/Checkbox';
import zIndex from '../../../globalVariables/zIndex';

function Row({rowKey, children, checked, rowHeight, isFloatingDragging}) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({
        id: rowKey
    });

    // Instead of creating a separate style object, let's pass these directly as props
    const transformValue = CSS.Transform.toString(transform);
    const transitionValue = transition || undefined;
    const zIndexValue = isDragging ? zIndex.baseHigh : undefined;

    const {isSelectable, isChecked, onChecked} = checked || {};

    return (
        <css.wrap isDragging={isDragging}>
            <css.row
                ref={setNodeRef}
                rowHeight={rowHeight}
                isDragging={isDragging}
                transformValue={transformValue}
                transitionValue={transitionValue}
                zIndexValue={zIndexValue}
                className={`row ${isDragging || isFloatingDragging ? 'isDragging' : ''} ${isChecked ? 'checked' : ''}`}
                data-cy="tableRow"
                {...attributes}
            >
                {isSelectable && (
                    <css.select>
                        <Checkbox selected={isChecked} onClick={(value) => onChecked?.(value)} />
                    </css.select>
                )}
                <css.drag {...listeners} className={`${isSelectable ? 'select' : ''} dragSign`} />
                {children}
            </css.row>
        </css.wrap>
    );
}

export default Row;